export default __webpack_public_path__ + "static/sf-ef47d98a4eddafdf442124f212fcca29.svg";